import React from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import {deepPurple} from "@mui/material/colors";
import GamesListRowVideo from "./GamesListRowVideo";
import {useTranslation} from "react-i18next";

function GamesListRowVideos(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'gamesListRowVideos' });
    const notProcessed = t('notProcessed')
    const processed = t('processed')
    const processing = t('processing')
    const processingError = t('processingError')



    function resolveRecordingStatus() {
        // let status = props.game.recording_status
        if (props.recordingStatus === null) {
            return "-"
        } else if (props.recordingStatus === "recorded") {
            return notProcessed
        } else if (props.recordingStatus === "processing") {
            return processing
        } else if (props.recordingStatus === "processed") {
            return processed
        } else if (props.recordingStatus === "processing_failed") {
            return processingError
        }
    }


    return (
        <>
            <div>
                <div><b>{t('gameVideo')}</b>: {resolveRecordingStatus()}
                    {(props.recordingStatus === "recorded" || props.recordingStatus === "processing_failed") &&
                        <button onClick={props.startVideoProcessing}
                                style={{
                                    backgroundColor: "var(--mentor-cabinet-edit_button)",
                                    color: deepPurple[500],
                                    cursor: "pointer",
                                    font: "var(--text-normal-font)",
                                    fontWeight: "600",
                                    borderRadius: "6px",
                                    border: "unset",
                                    padding: "10px 11px 11px 11px"
                                    // fontSize: "15px",
                                }}
                        >{t('process')}</button>}</div>
            </div>
            <div className={cabinetStyle.videosList}>
                {props.mentorVideos.length > 0 && props.mentorVideos.map((video) => {
                    return <GamesListRowVideo video={video} user_title={t('hostRecord')}/>
                })}
                {props.playerVideos.length > 0 && props.playerVideos.map((video) => {
                    return <GamesListRowVideo video={video} user_title={t('playerRecord') + video["user"]}/>
                })}
            </div>
        </>

    )
}

export default GamesListRowVideos